import PropTypes from 'prop-types';
import React from "react";
import FooterPageLayout from "~app/components/layouts/FooterPageLayout";
import { useT } from '~app/BundleProvider';

const Glossary = ({ mainRef }) => {
  const t = useT();
  return (
    <FooterPageLayout mainRef={mainRef}>
      <article>
        <h1>{t("glossary")}</h1>

        <p>
          <strong>{t("observation")}</strong>
        </p>

        <p>{t("observation-description")}</p>

        <p>
          <strong>{t("data")}</strong>
        </p>

        <p>{t("data-description")}</p>

        <p>
          <strong>{t("scientific-publications")}</strong>
        </p>

        <p>{t("scientific-publications-description")}</p>

        <p>
          <strong>{t("hypothesis")}</strong>
        </p>

        <p>{t("hypothesis-description")}</p>

        <p>
          <strong>{t("predictions")}</strong>
        </p>

        <p>{t("predictions-description")}</p>
        
        <p>
          <strong>{t("assumptions")}</strong>
        </p>

        <p>{t("assumptions-description")}</p>

        <p>
          <strong>{t("peer-review")}</strong>
        </p>

        <p>{t("peer-review-description")}</p>

        <p>
          <strong>{t("replication")}</strong>
        </p>

        <p>{t("replication-description")}</p>

        <p>
          <strong>{t("theory")}</strong>
        </p>

        <p>{t("theory-description")}  </p>
      </article>
    </FooterPageLayout>
  );
};

Glossary.propTypes = {
  mainRef: PropTypes.func.isRequired,
};

export default Glossary;



// WEBPACK FOOTER //
// ./src/pages/Glossary.js